import { useQuery, useQueryClient } from '@tanstack/react-query';
import { usePublicProgressStateStore, useUserUUID } from '@annunciate/core';
export const useCachedProgressItemQuery = (contentId = -1) => {
    const client = useQueryClient();
    const uuid = useUserUUID(true);
    const progressKey = `progress`;
    const cacheKey = [progressKey, { contentId, uuid }];
    return useQuery({
        queryKey: cacheKey,
        queryFn: async () => {
            let progress;
            if (uuid) {
                progress = client.getQueryData([
                    `progress`,
                    { contentId: contentId, uuid: uuid },
                ]);
            }
            else {
                progress = usePublicProgressStateStore
                    .getState()
                    .progress.find((item) => item.contentId === contentId);
            }
            return progress || {
                __typename: 'Progress',
                uuid,
                contentId,
                position: null,
            };
        },
        gcTime: Infinity,
        staleTime: Infinity,
    });
};
//# sourceMappingURL=useCachedProgressItemQuery.js.map